var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video",class:_vm.classes,style:(_vm.style)},[_c('video',{attrs:{"controls":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }